module.exports = __webpack_public_path__ + "img/aqfh-img-43.ff969af4.png";